import {
  DateParam,
  QueryParamConfigMap,
  StringParam,
  withDefault,
} from 'common/hooks/customSearchParams';

export const TERMINAL_SCREENSHOTS_PARAMS: QueryParamConfigMap = {
  mode: withDefault(StringParam, 'terminal'),
  terminal: StringParam,
  date: DateParam,
  time: StringParam,
};
